import React, { useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";
import ScrollShadow from "../../__shared/NFLTable";
import {
  buildMatchupColumns,
  rankCellProps,
  toMatchupRows,
} from "../matchupRows";

const OFFENSIVE_MATCHUP_RATINGS = graphql`
  query MatchupAdvantageTableQuery {
    nflOffensiveMatchupRankings {
      team {
        abbreviation
        name
      }

      opp {
        abbreviation
        name
      }

      teamTotal
      gameTotal

      passGameRank
      runGameRank
      onslaughtRank
    }
  }
`;

const DEFENSIVE_MATCHUP_RATINGS = graphql`
  query MatchupAdvantageTableDefenseQuery {
    nflDefensiveMatchupRankings {
      team {
        abbreviation
        name
      }

      opp {
        abbreviation
        name
      }

      teamTotal
      gameTotal

      defenseRank
    }
  }
`;

export default function MatchupAdvantageTable({ offense, fetchKey, emptyState }) {
  const queryData = useLazyLoadQuery(
    offense ? OFFENSIVE_MATCHUP_RATINGS : DEFENSIVE_MATCHUP_RATINGS,
    {},
    { fetchKey, fetchPolicy: fetchKey > 0 ? "network-only" : "store-or-network" }
  );

  const rankings = offense
    ? queryData.nflOffensiveMatchupRankings
    : queryData.nflDefensiveMatchupRankings;

  if (!rankings) {
    throw new Error(
      offense
        ? "nflOffensiveMatchupRankings returned null"
        : "nflDefensiveMatchupRankings returned null"
    );
  }

  const rows = useMemo(() => toMatchupRows(rankings), [rankings]);
  const columns = useMemo(() => buildMatchupColumns(offense), [offense]);
  const getCellProps = useMemo(() => rankCellProps(rows.length), [rows.length]);

  if (rows.length === 0) {
    return emptyState;
  }

  return (
    <ScrollShadow>
      <StatTable
        columns={columns}
        data={rows}
        getCellProps={getCellProps}
        interactiveCells={false}
        autoResetSortBy={false}
      />
    </ScrollShadow>
  );
}
